import { defaultQueryOptions } from 'constants/'
import { useQuery } from 'react-query'
import { QueryOptions } from 'types'
import { logFactory } from 'utils'
import { GetAudiogramQuery, useHearingTestService } from '../services'
import { groupWordRecognitionTests } from './groupWordRecognitionTests'

const hookName = 'useLatestWordRecognitionTests'
const log = logFactory(hookName)

const useLatestWordRecognitionTests = (customerGid?: string, options: QueryOptions = {}) => {
  const { getWordRecognitionTests } = useHearingTestService()

  const parameters = {
    customerId: customerGid as string,
  }

  const doQuery = async () => {
    const airConductionParams: GetAudiogramQuery = {
      ...parameters,
      conductionType: 'AC',
      sort: 'desc',
      sort_by: 'created_at',
    }

    const boneConductionParams: GetAudiogramQuery = {
      ...parameters,
      conductionType: 'BC',
      sort: 'desc',
      sort_by: 'created_at',
    }

    log(`👂 Fetching latest air conduction test result...`, airConductionParams)
    const airConductionPromise = getWordRecognitionTests(airConductionParams)

    log(`👂 Fetching latest air conduction test result...`, boneConductionParams)
    const boneConductionPromise = getWordRecognitionTests(boneConductionParams)

    const [airConductionResponse, boneConductionResponse] = await Promise.all([
      airConductionPromise,
      boneConductionPromise,
    ])

    log(`👂 Found latest test results for customer: ${customerGid}`, { airConductionResponse, boneConductionResponse })

    const grouped = groupWordRecognitionTests([...airConductionResponse.data, ...boneConductionResponse.data])

    log('🦻 Latest group test results', grouped)

    return grouped
  }

  return useQuery([hookName, parameters], doQuery, {
    ...defaultQueryOptions,
    enabled: Boolean(customerGid),
    ...options,
  })
}

export { useLatestWordRecognitionTests }
